import React from "react";
import { useNavigate } from "react-router-dom";
import posterImg from "../../assets/images/special-campaign-6-banner.jpg";
import { isSc6ViewOnly, SC6_LIMITS, SC6_LIVE_CAPTION, SC6_NAME, SC6_PATH, SC6_TITLE, SC6_UNDER } from "./sc6Config";
import Sc6Deco from "./Sc6Deco";
import "./Sc6.css";

/*
 * Landing-page banner for Special Campaign 6 — shown right under the
 * announcement strip while isSc6Shown() (HomePage). Light band: heading,
 * three "how it works" steps and the call to action on the left, the DoSEL
 * poster on the right; both lead to the upload form. Before the campaign day
 * the form is view-only, so the banner carries SC6_LIVE_CAPTION and the
 * button says "View the form".
 */
const STEPS = [
  { tone: "blue", text: "Enter your school’s UDISE code" },
  { tone: "green", text: "Answer 5 short questions" },
  { tone: "orange", text: `Upload ${SC6_LIMITS.photosMin}–${SC6_LIMITS.photosMax} geotagged photos` },
];

export default function Sc6Hero() {
  const navigate = useNavigate();
  const viewOnly = isSc6ViewOnly();
  const go = (e) => {
    e?.preventDefault?.();
    navigate(SC6_PATH);
  };

  return (
    <section className="sc6-banner sc6-band" aria-labelledby="sc6-banner-title">
      <Sc6Deco />
      <div className="sc6-banner__inner">
        <div className="sc6-banner__text">
          <span className="sc6-chip">{SC6_UNDER}</span>
          <h2 id="sc6-banner-title" className="sc6-banner__title">
            <a href={SC6_PATH} onClick={go}>
              National Event on <span className="sc6-banner__date">28 October 2026</span>
            </a>
          </h2>
          <p className="sc6-banner__sub">{SC6_TITLE}</p>
          {viewOnly && <p className="sc6-livenote">{SC6_LIVE_CAPTION}</p>}

          <ol className="sc6-how" aria-label="How it works">
            {STEPS.map((s, i) => (
              <li key={s.tone} className={`sc6-how__step sc6-how__step--${s.tone}`}>
                <span className="sc6-how__no">{i + 1}</span>
                <span className="sc6-how__text">{s.text}</span>
              </li>
            ))}
          </ol>

          <button type="button" className="sc6-cta" onClick={go}>
            <span>{viewOnly ? "View the form" : "Upload Participation Details"}</span>
            <span className="sc6-cta__arrow" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </span>
          </button>
        </div>

        <a className="sc6-poster sc6-poster--deco" href={SC6_PATH} onClick={go}>
          <img src={posterImg} alt={`${SC6_NAME}: ${SC6_TITLE}`} />
          <span className="sc6-poster__badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="4" y="11" width="16" height="10" rx="2.5" />
              <path d="M8 11V7.5a4 4 0 0 1 7.6-1.7" />
            </svg>
            <span>No login needed</span>
          </span>
        </a>
      </div>
    </section>
  );
}
